import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateTopic', standalone: true })
export class TruncateTopicPipe implements PipeTransform {
  transform(value: string, maxLength: number = 30): string {
    return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
  }
}
